<template lang="pug">
	span.asset-link-control(v-else-if="setting.control === 'asset-link'")
		select.custom-select.custom-select-sm(:name="setting.codename" v-on:change="Settings.setSettingValue(setting.codename, $event.target.value)")
			option(:selected="value === '#none'" value="#none") (none)
			option(v-for="v in assets" :selected="v === value" :value="v") {{v}}
</template>

<script>

	import Screen 					from './../../../mixins/screen';

	import { Project } 				from './../../../services/Project'
	import { Version } 				from './../../../services/Version'
	import { Asset } 				from './../../../services/Asset'
	import { Settings } 			from './../../../services/Settings'

	export default {
		name: 'AssetLinkControl',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Selected Version Settings Loaded", "Selected Version Settings Original Loaded", "Assets Changed"]
		},
		props: ['setting'],
		components: {},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			this.value = null;
			this.assets = {};

			return {
				showed: true
			};

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии проекта
			this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

		},
		watch: {
			setting(newVal, oldVal) {
				this.setting = newVal;
				this.collectData();
			}
		},
		methods: {

			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('AssetLinkControl collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.value = Settings.getSettingValue(this.setting.codename);
				this.assets = this.getAssetLinkControlValues(Version.SelectedVersion, this.setting.codename);

			},

			getAssetLinkControlValues(version, settingCodename) {

				let settingProps = Settings.getSettingProps(settingCodename);

				let assets = Asset.AssetsByVersion[version.id];

				let originalAssets = Asset.AssetsOriginalByVersion[version.id];

				if (assets) {

					for (let originalKey in originalAssets) {

						let assetChanged = false;

						let originalCodename = originalAssets[originalKey].codename;

						for (let key in assets) {

							let codename = assets[key].codename;

							if (originalCodename === codename) assetChanged = true;

						}

						if (!assetChanged) assets[originalKey] = originalAssets[originalKey];

					}

				}

				if (!assets) {

					assets = originalAssets;

					if (!assets) {

						return [];

					}

				}

				assets = _.filter(assets, asset => {

					return _.includes(settingProps.options.assetType, asset.type);

				});

				return _.map(assets, asset => asset.codename);

			}

		}
	}
</script>

<style lang="sass">

	.asset-link-control
		position: absolute
		right: 0
		top: -8px

</style>
